module.exports = __webpack_public_path__ + "media/src/assets/images/about_info-bg-d95ae49c4e323e218c77bbfc1bd1b819.jpg";